import bundledPlans from './multiattackPlans.json';
import { getMultiattackPlan as bindPlan } from '../../../shared/rules/enemyMultiattack.mjs';

// Inject the same reviewed catalog in both runtimes; rules stay pure ESM.
export const getMultiattackPlan = (enemy, multi) => bindPlan(enemy, multi, bundledPlans);
export { isMultiattackAction, createMultiattackSequence, chooseMultiattackVariant,
  multiattackChoices, selectMultiattackStep, bindMultiattackTarget,
  completeMultiattackStep, cancelMultiattackSelection } from '../../../shared/rules/enemyMultiattack.mjs';
